import apiClient from './client'

export const reelsApi = {
  getReels: async () => {
    const response = await apiClient.get('/reels')
    return response.data
  },

  getReel: async (id) => {
    const response = await apiClient.get(`/reels/${id}`)
    return response.data
  },

  markAsWatched: async (id) => {
    const response = await apiClient.post(`/reels/${id}/watch`)
    return response.data
  },

  likeReel: async (id) => {
    const response = await apiClient.post(`/reels/${id}/like`)
    return response.data
  },

  unlikeReel: async (id) => {
    const response = await apiClient.delete(`/reels/${id}/like`)
    return response.data
  },
}

